/* Shopify watch-interest navigation. No PII, paid identifiers or conversion sends. */
(function () {
  'use strict';
  var element = document.getElementById('nhl-watch-landing-config');
  if (!element) return;
  var config; try { config = JSON.parse(element.textContent); } catch (_) { return; }
  var profiles = config.profiles, key = 'generic', STORE = 'nhl:landing-context:v1', TTL = 86400000;
  var genericPath = config.genericUrl || '/pages/custom-watches';
  var adMap = {"120251151669040517":"sam","120251151667830517":"abyss","120251151670210517":"carbon","120251151668240517":"pearl","120250975032860517":"abyss","120250975032870517":"abyss","120251047552990517":"pearl","120251047512700517":"abyss","120251047475710517":"carbon","120250930873570517":"abyss","120250930873590517":"abyss","120250930805390517":"abyss","120250930873580517":"abyss","120250930873600517":"abyss"};
  function valid(value) { return value === 'generic' || (typeof value === 'string' && Object.prototype.hasOwnProperty.call(profiles, value) && !!profiles[value]); }
  function normalize(path) { return path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, '').replace(/\/$/,'') || '/'; }
  function locale() { return (location.pathname.match(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i)||[''])[0]; }
  function saved() {
    try { var s=JSON.parse(sessionStorage.getItem(STORE)); if(s && s.version===1 && valid(s.watch) && Date.now()>=s.at && Date.now()-s.at<TTL) return s.watch; } catch (_) {}
    return 'generic';
  }
  function resolve() {
    var hero=document.querySelector('[data-watch-landing]'),q=new URLSearchParams(location.search),path=normalize(location.pathname);
    if(hero && valid(hero.dataset.watchKey)) return hero.dataset.watchKey;
    var explicit=Object.keys(profiles).find(function(k){return path==='/pages/'+profiles[k].page;});
    if(explicit) return explicit;
    if(q.has('nhl_watch')) return valid(q.get('nhl_watch'))?q.get('nhl_watch'):'generic';
    if(q.has('utm_content')) {var ad=q.get('utm_content');return Object.prototype.hasOwnProperty.call(adMap,ad)?adMap[ad]:'generic';}
    if(path===normalize(genericPath)) return 'generic';
    return saved();
  }
  function landing(selected) {
    var u=new URL(genericPath,location.origin); u.pathname=locale()+normalize(u.pathname);
    if(selected!=='generic') {
      if(config.draftLinks) u.searchParams.set('view',profiles[selected].view);
      else u.pathname=locale()+'/pages/'+profiles[selected].page;
    }
    u.searchParams.set('nhl_watch',selected); return u;
  }
  function isSpecialEnquiry(u) { return u.searchParams.has('type') || u.searchParams.has('gallery_ref') || u.searchParams.has('source'); }
  function chosenPreset(u) { var handle=u.searchParams.get('preset');if(!handle)return;return Object.keys(profiles).find(function(k){return profiles[k].product===handle;}); }
  function decorate(anchor) {
    // Reuse our source URL only while the actual href is still our own decoration.
    // Gallery/product scripts can replace an existing anchor's destination.
    var currentHref=anchor.getAttribute('href');
    var raw=currentHref===anchor.__nhlDecoratedHref?anchor.__nhlOriginalHref:currentHref;
    anchor.__nhlOriginalHref=raw;anchor.__nhlDecoratedHref=currentHref;
    if(!raw || raw[0]==='#' || anchor.hasAttribute('download') || anchor.hasAttribute('data-watch-context-skip')) return;
    var u;try{u=new URL(raw,location.href);}catch(_){return;}
    if(!/^https?:$/.test(u.protocol) || u.origin!==location.origin) return;
    var path=normalize(u.pathname);
    if(/^\/(cart|checkout|checkouts|account|apps)(\/|$)/.test(path)) return;
    var selected=key,requested=u.searchParams.get('nhl_watch');
    var reset=anchor.hasAttribute('data-watch-reset') || requested==='generic';
    if(reset) selected='generic';
    else if(valid(anchor.dataset.watchSelect)) selected=anchor.dataset.watchSelect;
    else {var named=Object.keys(profiles).find(function(k){return path==='/pages/'+profiles[k].page;});if(named) selected=named;else if(u.searchParams.has('nhl_watch')) selected=valid(requested)?requested:'generic';}
    if(reset) u.searchParams.delete('preset');
    var preset=chosenPreset(u);if(preset && !reset) selected=preset;
    if(path===normalize(genericPath) || Object.keys(profiles).some(function(k){return path==='/pages/'+profiles[k].page;})) {
      if(!isSpecialEnquiry(u) && (!u.searchParams.has('preset') || preset)) {
        var next=landing(selected);u.pathname=next.pathname;
        u.searchParams.delete('view');if(next.searchParams.has('view')) u.searchParams.set('view',next.searchParams.get('view'));
      }
    }
    u.searchParams.set('nhl_watch',selected);
    var preview=config.draftLinks?String(config.themeId):new URLSearchParams(location.search).get('preview_theme_id');
    if(preview && preview===String(config.themeId)) u.searchParams.set('preview_theme_id',preview);
    anchor.__nhlDecoratedHref=u.href;
    if(currentHref!==u.href) anchor.setAttribute('href',u.href);
  }
  function reconcile() {
    key=resolve();try{sessionStorage.setItem(STORE,JSON.stringify({version:1,watch:key,at:Date.now()}));}catch(_){}
    document.querySelectorAll('a[href]').forEach(decorate);
    var form=document.getElementById('commission-form'),returnInput=form && form.querySelector('input[name="return_to"]');
    if(returnInput) {
      var back=new URL(location.pathname,location.origin),query=new URLSearchParams(location.search);
      ['view','nhl_watch'].forEach(function(name){if(query.has(name))back.searchParams.set(name,query.get(name));});
      back.searchParams.set('nhl_watch',key);
      back.searchParams.set('contact_posted','true');
      if(config.draftLinks)back.searchParams.set('preview_theme_id',String(config.themeId));
      returnInput.value=back.pathname+back.search;
    }
  }
  key=resolve();
  var current=new URL(location.href),isGeneric=normalize(current.pathname)===normalize(genericPath);
  var hero=document.querySelector('[data-watch-landing]');
  // Adapt old generic links to the real Shopify alternate template during draft review.
  if(isGeneric && !hero && key!=='generic' && !isSpecialEnquiry(current) && (!current.searchParams.has('preset')||chosenPreset(current))) {
    var next=landing(key);current.pathname=next.pathname;current.searchParams.set('nhl_watch',key);
    current.searchParams.delete('view');if(next.searchParams.has('view'))current.searchParams.set('view',next.searchParams.get('view'));
    if(current.href!==location.href){location.replace(current.href);return;}
  }
  reconcile();window.addEventListener('pageshow',reconcile);
  new MutationObserver(function(records){records.forEach(function(r){
    if(r.type==='attributes') {
      var anchor=r.target;if(!anchor.matches('a[href]'))return;
      // Our own href write is already complete; avoid a self-triggering observer loop.
      if(r.attributeName==='href' && anchor.getAttribute('href')===anchor.__nhlDecoratedHref)return;
      decorate(anchor);return;
    }
    r.addedNodes.forEach(function(n){if(n.nodeType!==1)return;if(n.matches('a[href]'))decorate(n);n.querySelectorAll('a[href]').forEach(decorate);});
  });}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['href','data-watch-select','data-watch-reset']});
})();
